import i18n from '@/i18n'

export function defaultExternalFormElements() {
  return [
    {
      element_type: 'paragraph',
      content: i18n.t('ui.drag_elements.paragraph')
    },
    {
      element_type: 'title',
      content: i18n.t('ui.drag_elements.title')
    },
    {
      element_type: 'confirmation',
      content: i18n.t('ui.drag_elements.confirmation'),
      required: true
    }
  ]
}

export function defaultLeadMaskElementsStandard() {
  return [
    {
      element_type: 'radio',
      label: i18n.t('ui.drag_elements.gender'),
      name: 'gender',
      allowed_values: [
        {
          name: "Male",
          value: "male"
        },
        {
          name: "Female",
          value: "female"
        }
      ],
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.firstname'),
      name: 'firstname',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.lastname'),
      name: 'lastname',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.email'),
      name: 'email',
      data_type: 'email',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.company'),
      name: 'company',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.street'),
      name: 'street',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.street_number'),
      name: 'street_number',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.zip'),
      name: 'zip',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.city'),
      name: 'city',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'country_select',
      label: i18n.t('ui.drag_elements.country'),
      name: 'country',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.website'),
      name: 'company_website',
      data_type: 'url',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.phone_company'),
      name: 'phone_company',
      data_type: 'tel',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    },
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.phone_mobile'),
      name: 'phone_mobile',
      data_type: 'tel',
      shouldBeDeleted: true,
      isUniqueInCollection: true
    }
  ]
}

export function defaultLeadMaskElementsAdvanced() {
  return [
    {
      element_type: 'text',
      label: i18n.t('ui.drag_elements.textfield')
    },
    {
      element_type: 'textarea',
      label: i18n.t('ui.drag_elements.long_textfield')
    },
    {
      element_type: 'paragraph',
      content: i18n.t('ui.drag_elements.paragraph'),
    },
    {
      element_type: 'title',
      content: i18n.t('ui.drag_elements.title')
    },
    {
      element_type: 'checkbox',
      label: i18n.t('ui.drag_elements.multi_select'),
      allowed_values: [
        {
          name: "Name",
          value: "value_1"
        }
      ]
    },
    {
      element_type: 'select',
      label: i18n.t('ui.drag_elements.dropdown'),
      allowed_values: [
        {
          name: "Name",
          value: "value_1"
        }
      ]
    },
    {
      element_type: 'radio',
      label: i18n.t('ui.drag_elements.single_select'),
      allowed_values: [
        {
          name: "Name",
          value: "value_1"
        }
      ]
    },
    {
      element_type: 'date',
      label: i18n.t('ui.drag_elements.date')
    },
    {
      element_type: 'readonly',
      label: i18n.t('ui.drag_elements.readonly')
    },
    {
      element_type: 'quantity_selection',
      label: i18n.t('ui.drag_elements.quantity_selection')
    },
    {
      element_type: 'drawing',
      label: i18n.t('ui.drag_elements.drawing')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/config/data/dragDefaultElements.js